import "../../packages/ui/src/styles/index.scss";

import { pushVirtualPageView } from "@repo/analytics";

export const onClientEntry = () => {
  // Add a site-specific className to <html>
  document.documentElement.classList.add("patient-ppl");

  // Prevent browser history from restoring scroll positions on SPA navigation.
  if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }
};

export const shouldUpdateScroll = ({ routerProps }) => {
  // Hash scrolling is handled in onRouteUpdate so it can stay smooth.
  if (routerProps?.location?.hash) {
    return false;
  }

  // Return false so Gatsby does not attempt any scroll management.
  // onRouteUpdate owns all scroll-to-top logic.
  return false;
};

const scrollToTop = () => {
  if (typeof window === "undefined") return;

  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
};

const scrollToHash = (hash) => {
  if (typeof document === "undefined") return;

  const id = decodeURIComponent(hash.replace(/^#/, ""));
  if (!id) return;

  const target = document.getElementById(id);

  if (target) {
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  // Initial-load page context is pushed by the head init script;
  // only emit a virtual pageview for in-app (SPA) navigations.
  if (prevLocation) {
    pushVirtualPageView("patient_ppl", location?.pathname);
  }

  if (location?.hash) {
    requestAnimationFrame(() => {
      scrollToHash(location.hash);
    });
    return;
  }

  // rAF x2 handles most cases; setTimeout catches any deferred
  // Gatsby scroll restoration that fires after the animation frames.
  requestAnimationFrame(() => {
    scrollToTop();
    requestAnimationFrame(() => {
      scrollToTop();
      setTimeout(scrollToTop, 0);
    });
  });
};
